import React from 'react';
import './Profile.css';

import { Address, Button, Heading, PageTitle } from '../../../components';
import { profile } from '../../../constants';

   
   
const Profile = () => {
    const addressDetails = profile.address;
  return ( 
     <> 
        <PageTitle title={'profile'} page={'profile'} />
        <section className='profile'>

            <div className='box-container'> 
                
                <div className='profile-item profile-details'>
                    <Heading title={'profile details'} />
                    <div className='content' >
                        <img src={profile.image} alt="" />
                        <h3>{profile.name}</h3>
                        <p className='gmail'>{profile.gmail}</p>
                        <p>{profile.contactNo}</p>
                        <Button link={'/edit-profile'} title={'edit profile'} />
                    </div> 
                </div>
 
                <div className='profile-item address-details'>
                    <Heading title={'address details'} />
                    <div className='content'>
                        <div className='address-container'>
                            {
                                addressDetails.map((item) => {
                                    return(
                                        <Address 
                                        key={item.id}
                                        id={item.id}
                                        title={item.title}
                                        name={item.name}
                                        country={item.country}
                                        city={item.city}
                                        province={item.province}
                                        ZIP={item.ZIP}
                                        address={item.address} />
                                    )
                                })
                            }
                        </div> 
                        <Button link={'/edit-address'} title={'edit address'} />
                    </div>

                </div>
                
            </div>

        </section>
    </> 
  )
}

export default Profile;